import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };

export const ListUsers = async (filters = {}) => {
    return await axiosInstance(options).get(`admin/payments/users${objToURL(filters)}`);
};

export const GetUserDetails = async (userId) => {
    return await axiosInstance(options).get(`admin/payments/user/${userId}`);
};

export const ToggleAllowSubscription = async (userId, allowed) => {
    return await axiosInstance(options).post(`admin/payments/toggle-allow`, { userId, allowed });
};

export const AdminCreateCheckout = async (userId) => {
    return await axiosInstance(options).post(`admin/payments/admin-checkout`, { userId });
};

export const CreateCheckoutSession = async (role = ROLE.SUPER_ADMIN) => {
    // Uses the role option based on the logged-in user context
    return await axiosInstance({ role }).post(`common/payments/checkout`);
};
